import { TextButton } from '../../text-button/text-button.component';
import { TimelineActionButtonProps } from '../timeline.types';

export function TimelineActionButton({ buttonLabel, buttonColor, onClick }: TimelineActionButtonProps) {
  return (
    <TextButton
      fullWidth
      color="primary"
      fontSize="12px"
      style={{
        color: buttonColor,
        borderColor: buttonColor,
        maxWidth: '300px',
        height: '32px',
        margin: '16px 0'
      }}
      variant="outlined"
      onClick={onClick}
    >
      {buttonLabel}
    </TextButton>
  );
}
